import { fetchConfig } from '@theme/utilities';
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * Kayuri: "Te podría interesar" en el cajón del carrito.
 * Añade el producto del metaobject "one_more" por AJAX y notifica al tema con
 * el mismo contrato de eventos que product-form.js, para que contador, lista de
 * artículos y resumen se actualicen sin recargar.
 */
const RESET_DELAY = 2500;

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('.one-more-add');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const originalLabel = button.innerHTML;
  const originalAria = button.getAttribute('aria-label') || '';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const body = JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') });
    const response = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'add failed');

    const cartResponse = await fetch(`${Theme.routes.cart_url}.js`);
    const ajaxCart = await cartResponse.json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'kayuri-one-more',
        itemCount: 1,
        sections: data.sections,
        didError: false,
      },
    });
  } catch (error) {
    console.error('[kayuri-one-more]', error);
    deferred.reject(error);
    button.dispatchEvent(new CartErrorEvent({ error: String(error?.message || error), code: 'INVALID' }));

    // Aviso en el propio botón, sin alert() bloqueante.
    button.classList.add('is-error');
    button.setAttribute('aria-label', 'No se pudo añadir');
    window.setTimeout(() => {
      button.classList.remove('is-error');
      button.setAttribute('aria-label', originalAria);
    }, RESET_DELAY);
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.innerHTML = originalLabel;
  }
});
